import React, { ReactNode } from 'react';
import { SubmitHandler } from '../types';
import '../../styles/forms-form.scss';

interface Props {
  className?: string;
  onSubmit?: SubmitHandler;
  children?: ReactNode;
  autoComplete?: string;
}

const Form = ({ children, onSubmit, className, ...props }: Props) => (
  <form className={`${className} forms-form`} onSubmit={onSubmit} {...props}>
    {children}
  </form>
);

export default Form;
